import axios from "axios";

// API DESTE PROJETO - MONITORAMENTO
export const projectApi = axios.create({
  baseURL: "http://192.168.0.11:3002",
});

projectApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("palmaresAuthToken");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// API ROTEAMENTO
export const routingApi = axios.create({
  baseURL: "http://192.168.0.11:3010",
});

export default projectApi;
